var scope_0 = require('/builds/Marketing/blog-smc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/263f31929b45dfdb4d59630586fa2b4f.js').default;
var scope_1 = require('/builds/Marketing/blog-smc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3543bc0b05606b9842466ad2dabff99a.js').default;
var scope_2 = require('/builds/Marketing/blog-smc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/48f7d755fffb16454b5f5ddd92e581e4.js').default;
var scope_3 = require('/builds/Marketing/blog-smc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4acef72a95bf743d45457843987ca35a.js').default;
var scope_4 = require('/builds/Marketing/blog-smc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/51c93a5440d2389453195ce4f11b41a5.js').default;
var scope_5 = require('/builds/Marketing/blog-smc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9bd1f8a490863d63ce166fa7851e229e.js').default;
var scope_6 = require('/builds/Marketing/blog-smc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c3ea265dd2ae6a837393e3f0fff1341f.js').default;
var scope_7 = require('/builds/Marketing/blog-smc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cdcd79cc9cb2b6870a6ec7f3c1df15b4.js').default;
var scope_8 = require('/builds/Marketing/blog-smc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d6e198f723498cef05bef9de4d759591.js').default;
var scope_9 = require('/builds/Marketing/blog-smc/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9 )
    